import React, {Component} from 'react'
import {Container, Row, Col, ButtonLight, ButtonPrimary} from '@modifi/ui'
import {white} from '@modifi/colors'
import PropTypes from 'prop-types'
import {KEY_JANUS, translate, Trans} from '@modifi/plugin-i18n'
import {compose} from 'ramda'

import {setUserConsent, getUserConsent} from '../../../utils/consent-cookie'
import {Wrapper, StyledLink, StyledSmall} from './styles'

// we are setting user consent into three different categories
// 1. Functionality = 10
// 2. Tracking = 20
// 3. Marketing = 30

class CookieBar extends Component {
  static propTypes = {
    extraLinks: PropTypes.shape({
      facebook: PropTypes.string,
      home: PropTypes.string,
      linkedIn: PropTypes.string,
      login: PropTypes.string,
      signup: PropTypes.string,
      twitter: PropTypes.string,
      termsOfUse: PropTypes.string,
      privacyPolicy: PropTypes.string,
    }).isRequired,
    t: PropTypes.func.isRequired,
  }

  static defaultProps = {}

  timeout = null

  // eslint-disable-next-line react/state-in-constructor
  state = {
    isVisible: false,
  }

  componentDidMount() {
    const userConsent = getUserConsent()
    this.timeout = setTimeout(() => this.setState({isVisible: userConsent === undefined}), 1)
  }

  componentWillUnmount() {
    clearTimeout(this.timeout)
  }

  decline = () => {
    this.setState({isVisible: false}, () => setUserConsent(10))
  }

  accept = () => {
    this.setState({isVisible: false}, () => setUserConsent(30))
  }

  render() {
    const {t, extraLinks} = this.props
    const {isVisible} = this.state
    return (
      <Wrapper isVisible={isVisible}>
        <Container>
          <Row alignItems="center" justifyContent="center" mdJustifyContent="between">
            <Col md mt={30} mb={20} mdMy={40}>
              <StyledSmall color={white}>
                <Trans
                  t={t}
                  i18nKey="cookie.info.text"
                  components={{
                    aTerms: <StyledLink to={extraLinks?.termsOfUse} color={white} />,
                    aPolicy: <StyledLink to={extraLinks?.privacyPolicy} color={white} />,
                  }}
                />
              </StyledSmall>
            </Col>
            <Col auto mb={30} mdMy={40}>
              <ButtonLight
                data-target="cookie-accept-10"
                onClick={this.decline}
                inverse
                transparent
                data-track-category="cookie-consent-dialog"
                data-track-click-action="submit-button-clicked"
                data-track-click-label="consent-10"
              >
                {t('cookie.decline')}
              </ButtonLight>
              <ButtonPrimary
                data-target="cookie-accept-30"
                onClick={this.accept}
                data-track-category="cookie-consent-dialog"
                data-track-click-action="submit-button-clicked"
                data-track-click-label="consent-30"
              >
                {t('cookie.accept')}
              </ButtonPrimary>
            </Col>
          </Row>
        </Container>
      </Wrapper>
    )
  }
}

export default compose(translate(KEY_JANUS))(CookieBar)
